import { Component, Fragment } from 'react'
import { triggerFilter } from './MobileFilterToggle'
import { FormattedMessage } from 'react-intl'
import RatingStars from '../helpers/RatingStars'
import TripOrganiser from '../search-group/TripOrganiser'

export default class FilterList extends Component {
  constructor(props) {
    super(props)

    this.state = {
      filtersToggler: {
        price: true,
        duration: true,
        diving_intensity: true,
        experience: true,
        tag: true,
        ...props.expandedFilters,
      },
    }
  }

  toggleFilter = (filterId) => {
    let filtersToggler = Object.assign({}, this.state.filtersToggler)

    filtersToggler[filterId] = !filtersToggler[filterId]

    this.setState({
      filtersToggler,
    }, () => {
      console.log(this.state.filtersToggler)
    })
  }

  updateCheckbox = (filter, id, value, item = {}) => {
    let secondLevelItems = {}
    if(item.subitems && item.subitems.length > 0) {
      secondLevelItems = {
        'marine_life_critters': { ...this.props.selectedFilters.marine_life_critters },
      }

      item.subitems.map(function(subitem) {
        secondLevelItems['marine_life_critters'][subitem.id] = value
      })
    }

    this.props.updateParams({
      [filter]: {
        ...this.props.selectedFilters[filter],
        [id]: value,
      },
      ...secondLevelItems,
    })
  }

  render() {
    return (
      <div className='filter-list' id='filter-list'>
        <p>
          <FormattedMessage id='filter_by' defaultMessage='Filter by' />
          {
            this.props.filtersCount
              ? (<span className='clear-filter' onClick={this.props.clearSelectedFilters}>
                <FormattedMessage id='clear_filters' defaultMessage='Clear all filters' />
              </span>) : ''
          }
          <span className='close close-icon visible-xs' onClick={triggerFilter} />
        </p>

        { this.props.showTripOrganiser && (
          <div className='filter-row'>
            <p className='title hide-arrow'><FormattedMessage id='tripOrganiser' defaultMessage='Trip organiser' /></p>

            <div className='form-group w_icon'>
              <i className='font-icons field-icon find-icon' />
              <TripOrganiser callback={this.props.updateParams} inputValue={this.props.selectedFilters.organiserTitle} model={this.props.model} pk={this.props.pk} />
            </div>
          </div>
        )}

        {
          this.props.items && this.props.items.map((filter, key) => {
            if(filter.items.length === 0) {
              return false
            }

            let uniqueKey = filter.query_name

            if(filter.query_name === 'parameters') {
              uniqueKey += key
            }

            let arraySliceOption = [0, !this.state.filtersToggler[uniqueKey + '_inner'] ? 5 : filter.items.length]

            if(filter.query_name === 'duration' && filter.items.length > 5) {
              arraySliceOption = [
                !this.state.filtersToggler[uniqueKey + '_inner'] ? 5 : 0,
                !this.state.filtersToggler[uniqueKey + '_inner'] ? 10 : filter.items.length]
            }

            if(!this.props.selectedFilters['is_promotion']) {
              this.props.selectedFilters['is_promotion'] = {}
            }

            return (
              <div className='filter-row' key={uniqueKey}>
                <p className={`title ${this.state.filtersToggler[uniqueKey] ? '' : 'active'}`} onClick={() => this.toggleFilter(uniqueKey)}>{filter.title}</p>
                <ul className={`fade-onload ${this.state.filtersToggler[uniqueKey] ? '' : 'hidden'}`}>
                  {
                    filter.items.slice(...arraySliceOption).map((item, key) => {
                      let queryName = filter.query_name

                      if(item.subitems.length > 0) {
                        queryName = 'marine_life_group_critters'
                      }

                      if(!this.props.selectedFilters[queryName]) {
                        this.props.selectedFilters[queryName] = {}
                      }

                      if(!this.props.selectedFilters[filter.query_name]) {
                        this.props.selectedFilters[filter.query_name] = {}
                      }

                      return (<li key={item.id} className={`fade-onload ${item.subitems.length > 1 ? 'two-level-list' : ''}`}>
                        <label className='checkbox-wrap'>
                          <input type='checkbox'
                            onChange={(e) => this.updateCheckbox(queryName, item.id, e.target.checked, item)}
                            checked={this.props.selectedFilters[queryName][item.id] || false} />
                          <span />
                          {
                            item.subitems.length <= 1
                              ? (<Fragment>
                                {
                                  queryName === 'stars'
                                    ? (<RatingStars rating={item.id} maxStars={6} className='stars' />)
                                    : (<p>{item.title}</p>)
                                }
                              </Fragment>)
                              : ''
                          }
                        </label>
                        { item.subitems.length > 1
                          ? (
                            <Fragment>
                              <p className={`second-level-arrow ${this.state.filtersToggler[uniqueKey + item.id] ? 'active' : ''}`}
                                onClick={() => this.toggleFilter(uniqueKey + item.id)}>{ item.title }</p>
                              {
                                this.state.filtersToggler[uniqueKey + item.id] ? (
                                  <ul className='fade-onload' ng-show='marineLifeExpandedGroup[{{forloop.counter}}]'>
                                    {
                                      item.subitems.map((subitem) => {
                                        return (<li key={subitem.id}>
                                          <label className='checkbox-wrap'>
                                            <input className='mkt_search_advanced_filter'
                                              type='checkbox'
                                              onChange={(e) => this.updateCheckbox(filter.query_name, subitem.id, e.target.checked, subitem)}
                                              checked={this.props.selectedFilters[filter.query_name][subitem.id] || false} />
                                            <span />
                                            <p>{ subitem.title }</p>
                                          </label>
                                        </li>)
                                      })
                                    }
                                  </ul>) : ''
                              }
                            </Fragment>
                          ) : ''
                        }
                      </li>)
                    })
                  }
                  {
                    filter.query_name === 'price' && !this.props.diveResort && !this.props.groupTrips ? (
                      <li>
                        <label className='checkbox-wrap'>
                          <input type='checkbox'
                            onChange={(e) => this.updateCheckbox('is_promotion', 'promotion', e.target.checked)}
                            checked={this.props.selectedFilters['is_promotion']['promotion'] || false} />
                          <span />
                          <p><FormattedMessage id='only_special_deals' defaultMessage='Only special deals' /></p>
                        </label>
                      </li>
                    ) : ''
                  }
                  {
                    filter.items.length > 5
                      ? (<li className='fade-onload show-all' onClick={() => this.toggleFilter(uniqueKey + '_inner')}>
                        {
                          this.state.filtersToggler[uniqueKey + '_inner'] ? (
                            <Fragment>
                              <FormattedMessage id='search.show_less' defaultMessage='Show less' /><i className='font-icons top-arrow-icon' />
                            </Fragment>
                          )
                            : (
                              <Fragment>
                                <FormattedMessage id='search.show_all' defaultMessage='Show all {quantity}' values={{
                                  quantity: filter.items.length,
                                }} /><i className='font-icons bottom-arrow-icon' />
                              </Fragment>
                            )
                        }
                      </li>) : ''
                  }
                </ul>
              </div>
            )
          })
        }
        <button className='done btn-red visible-xs' onClick={triggerFilter}><FormattedMessage id='done' defaultMessage='Done' /></button>
      </div>
    )
  }
}
